<template>
  <hm-content title="">
    <div class="temp-header flex flex-between">
      <div @click="back" class="btn">
        <span class="hmicon icon-fanhui"></span>
        返回
      </div>
      <div></div>
    </div>
    <div class="p20 flex flex-warp">
      <div style="width:220px;">
        <el-table
          stripe
          border
          ref="table"
          :data="srcList"
          highlight-current-row
          style="width: 100%"
          @current-change="handleCurrentChange"
          size="small"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="taskName"
            label="小票图片列表"
          >
            <template slot-scope="scope">
              <img
                style="width: 100px; height: 100px"
                :src="scope.row"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="ml10" style="width:400px;height:600px">
        <!-- <div class="flex upload-upload-btn">
          <div
            class="btn flex flex-column  flex-center open-file"
            v-if="!ocrImg"
            @click="showImg = true"
          >
            <div class="add-wrapper">
              <span class="hmicon icon-hao pointer"></span>
            </div>
            <span>上传小票模板</span>
          </div>
          <div v-if="ocrImg" class="mr10 priview">
            <img class="logo" :src="ocrImg" alt="logo" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
        </div> -->
        <!-- <el-button
          type="primary"
          size="small"
          v-show="!ocrImg"
          @click="showImg = true"
          >上传小票图片</el-button
        > -->
        <div class="priview" v-if="ocrImg">
          <img :src="ocrImg" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="handleRemove">删除</el-button>
          </div>
        </div>
        <el-upload
          v-if="!ocrImg"
          class="upload flex"
          ref="upload"
          :limit="1"
          drag
          :data="{ fileDir: 'mall' }"
          :headers="{ 'X-Access-Token': $token }"
          :action="$uploadUrl"
          :on-remove="handleRemove"
          :onError="uploadError"
          :onSuccess="uploadSuccess"
          :beforeUpload="beforeAvatarUpload"
          :onProgress="uploading"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将图片拖到此处，或
            <em>点击上传</em>
          </div>
        </el-upload>
      </div>
      <div class="ml10 mr20" style="width:300px">
        <div class="title">
          OCR识别结果
        </div>
        <div class="ocr scrollocr">
          <div v-for="(v, i) in orcList" :key="i" class="mb10">
            {{ v }}
          </div>
        </div>
      </div>
      <div class="ml20 flex-1">
        <div class="title">
          小票规则
        </div>
        <div class="form-red">以下输入框请复制OCR识别结果,不要手动输入!!!</div>
        <el-form
          ref="ruleForm"
          :model="ruleForms"
          :rules="rules"
          label-width="150px"
        >
          <div class="info-title">
            添加成长值等级
          </div>
          <el-form-item label="小票商户名称:" prop="receiptStoreName">
            <el-input
              clearable
              v-model="ruleForms.receiptStoreName"
              maxlength="20"
              size="small"
              placeholder="请复制OCR识别的商户名称"
            ></el-input>
          </el-form-item>
          <div class="info-title">
            小票号规则
          </div>

          <el-form-item label="关键字前缀：" prop="receiptSnKeyPrefix">
            <el-input
              clearable
              placeholder="请输入小票号关键字前缀"
              v-model="ruleForms.receiptSnKeyPrefix"
              maxlength="20"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="关键字后缀：" prop="receiptSnKeySuffix">
            <el-input
              clearable
              placeholder="请输入小票号关键字后缀"
              v-model="ruleForms.receiptSnKeySuffix"
              maxlength="20"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="票号模板：" prop="receiptSnTemplate">
            <el-input
              clearable
              id="selectedArticle"
              placeholder="请复制OCR识别的小票号"
              v-model="ruleForms.receiptSnTemplate"
              size="small"
            ></el-input>
          </el-form-item>
          <div class="info-title">
            小票日期规则
          </div>
          <el-form-item label="关键字前缀：" prop="receiptDateKeyPrefix">
            <el-input
              clearable
              placeholder="请输入小票日期前缀"
              v-model="ruleForms.receiptDateKeyPrefix"
              maxlength="20"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="关键字后缀：" prop="receiptDateKeySuffix">
            <el-input
              clearable
              placeholder="请输入小票日期后缀"
              v-model="ruleForms.receiptDateKeySuffix"
              maxlength="20"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="日期格式：" prop="receiptDateModel">
            <el-select
              clearable
              size="small"
              v-model="ruleForms.receiptDateModel"
              placeholder="请选择日期格式"
            >
              <el-option
                :label="v.itemText"
                :value="v.itemValue"
                v-for="(v, i) in dateList"
                :key="i"
              >
              </el-option>
              <!-- <el-option label="小时" :value="1"> </el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="日期模板：" prop="receiptDateTemplate">
            <el-input
              clearable
              placeholder="请复制OCR识别的日期"
              v-model="ruleForms.receiptDateTemplate"
              maxlength="20"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="confirm()"
            >保 存</el-button
          >
        </div>
      </div>
    </div>
    <!-- <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="showImg"
      noCircle
      noSquare
      :noRotate="false"
      :width="200"
      :height="200"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload> -->
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  components: { myUpload },
  data() {
    return {
      ocrImg: "",
      showImg: false,
      ruleForms: {
        receiptStoreName: "",
        receiptSnKeyPrefix: "",
        receiptSnKeySuffix: "",
        receiptSnTemplate: "",
        receiptDateKeyPrefix: "",
        receiptDateKeySuffix: "",
        receiptDateModel: "",
        receiptDateTemplate: ""
      },
      rules: {
        receiptStoreName: {
          required: true,
          message: "请复制OCR识别的商户名称",
          trigger: "blur"
        },
        receiptSnTemplate: {
          required: true,
          message: "请复制OCR识别的小票号",
          trigger: "blur"
        },
        receiptDateModel: {
          required: true,
          message: "请选择日期格式",
          trigger: "blur"
        },
        receiptDateTemplate: {
          required: true,
          message: "请复制OCR识别的日期",
          trigger: "blur"
        }
      },
      dateList: [],
      orcList: [],
      srcList: [],
      total: 0,
      currentPage: 1,
      pageSize: 5
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$store.dispatch("queryDictItems").then(res => {
      this.dateList = res.result;
    });
    this.queryOcrImgList();
    this.queryDetails();
  },
  methods: {
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryOcrImgList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryOcrImgList();
    },
    async queryOcrImgList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      Object.assign(params, this.$route.query);
      const { result } = await this.$store.dispatch("queryOcrImgList", params);
      const { records, total } = result;
      this.srcList = records;
      this.total = total;
    },
    handleCurrentChange(val) {
      this.ocrImg = val;
      this.queryOcrResult(val);
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.ocrImg = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
      this.queryOcrResult(response.result);
    },
    handleRemove() {
      this.ocrImg = "";
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch(
        "detailsOcrRule",
        this.$route.query
      );
      for (let key in result) {
        this.ruleForms[key] = result[key];
      }
      // this.ocrImg = result.receiptTemplateImg || "";

      // this.orcList = result.receiptOcrResult.split(",");
    },
    async queryOcrResult(img) {
      const { result } = await this.$store.dispatch("queryOcrResult", {
        receiptTemplateImg: img
      });
      this.orcList = result;
    },
    async confirm() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let params = this.ruleForms;
        params.ocrResultList = this.orcList;
        params.receiptTemplateImg = this.ocrImg;

        Object.assign(params, this.$route.query);
        const { code } = await this.$store.dispatch("addOcrRule", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryDetails();
        }
      } else {
        return false;
      }
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.showImg = false;
    },
    // 正在上传
    uploading() {
      this.showImg = true;
    },
    // 上传前对文件的大小的判断
    beforeAvatarUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 100;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 100k!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
    },
    back() {
      this.$router.back(-1);
    },
    // 获取选中的文本
    getSelectText() {
      var txt = "";
      if (document.selection) {
        txt = document.selection.createRange().text;
      } else {
        txt = document.getSelection();

        //txt = window.getSelection();
      }
      return txt.toString();
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.temp-header {
  height: 50px;
  line-height: 50px;
  background: rgba(255, 255, 255, 1);
  color: #000;
  //   padding: 0 22px;
  font-size: 16px;
  user-select: none;
  .hmicon {
    color: #e50065;
    font-size: 18px;
  }
  .btn {
    cursor: pointer;
  }
  .title {
    font-size: 18px;
  }
  .sub-title {
    font-size: 14px;
  }
  .header-list {
    li {
      border-right: 1px solid #fff;
      padding: 0 22px;
    }
    li:last-child {
      padding-right: 0;
      border-right: 0;
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    // width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.logo {
  width: 100%;
}
.info-title {
  font-weight: 600;
  font-size: 16px;
  margin-left: 15px;
}
.ocr {
  background: rgba(255, 249, 252, 1);
  border: 1px solid rgba(229, 0, 101, 1);
  border-radius: 6px;
  // width: 280px;
  height: 500px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
}
.scrollocr::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
.scrollocr::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.scrollocr::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.priview {
  position: relative;
  // width: 100%;
  width: 400px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    // height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
